import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { ThemingEffects } from './+state/theming.effects';

@NgModule({
  imports: [EffectsModule.forFeature([ThemingEffects])]
})
export class ThemingModule {}
